import React from "react";
import ApproveSIteTask from "./ApproveSIteTask";
import ApproveChangeTask from "./ApproveChangeTask";
import Api from '../../services/Api'

class SingleTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showApproveDialog: false,
        }
    }
    _onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open(this.props.site.url, '_blank');
    }

    _closeModal = () => {
        this.setState({showModal: false})
    }

    onRejectDecision(comment)
    {
        const url = '/CreateSiteReject'
        this.postDecision(comment, url);
        this._closeModal();
    }

    onApproveDecision(comment)
    {
        const url = '/CreateSiteApprove';
        this.postDecision(comment,url);
        this._closeModal();
    }

    onRejectChange(comment)
    {
        const url = '/RejectSiteChange'
        this.postDecision(comment,url);

        this._closeModal();
    }

    onApproveChange(comment)
    {
        const url = '/ApproveSiteChange';
        this.postDecision(comment,url);
        this._closeModal();
    }

    postDecision(comment,urlPart)
    {
        const post = {
            id: this.props.element.id,
            comment
        };

        Api.post(urlPart, post)
            .then(res => res.data)
            .then(post => {
                    if (post === 200) {
                        this.props.refresh();
                    } else {

                        console.log("Update failed")
                    }
                }
            ).catch((error) => {
            console.log(error)})
    }

    render() {
        const toRender = this.props.element.label === 'createTask' ? 
            <ApproveSIteTask
                site = {this.props.element}
                onReject = {this.onRejectDecision.bind(this)}
                onApprove = {this.onApproveDecision.bind(this)}
            /> :
            <ApproveChangeTask
                change = {this.props.element}
                onApprove={this.onApproveChange.bind(this)}
                onReject = {this.onRejectChange.bind(this)}
                types = {this.props.changeTypes}/>
        return(
            toRender
        );
    }
}
export default SingleTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SingleTask.js